import React from "react";
import Bg from "@/assets/images/product/cultivate/bg.jpeg";
import Cult1 from "@/assets/images/product/cultivate/cult1.png";
import Cult2 from "@/assets/images/product/cultivate/cult2.png";

const Cultivate: React.FC = () => {
  return (
    <main className='warp-consult wrap-scheme warp-visit header-top'>
      <div className='warp-consult-header'>
        <img src={Bg} alt=""/>
      </div>
      <div className='home-page warp-visit-content-items'>
        <div className='content-item' style={{padding: '0px'}}>
          <div className='content-item-block'>
            <div className='b-content p-pre-wrap'>
              采用「线下精品课 + 线上微课堂」双线课程体系，兼顾系统化深度集训与碎片化日常自学。线下课程覆盖党史学习、党务实操、党业融合、智慧党建四大学习方向；线上微课涵盖8 大模块、69 个系统化微课单元，依托线上平台实现随时学、随地学，常态化夯实党务知识、创新党建思路。
            </div>
          </div>
        </div>
      </div>
      <div className='wrap-bank-list' style={{paddingBottom: '0px'}}>
        <div className='wrap-bank-list-summary' style={{paddingTop: '0px'}}>
          <div className='home-page'>
            <div className='summary-data'>
              <div className='summary-data-block'>
                <div  className='summary-data-block-text' style={{marginBottom: '20px'}}>
                  线下课程
                </div>
                <img src={Cult1} alt=""/>
              </div>
              <div className='summary-data-block'>
                <div className='summary-data-block-text'  style={{marginBottom: '20px'}}>
                  线上课程
                </div>
                <img src={Cult2} alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='warp-visit-content' >
        <div className='home-page warp-visit-content-items'>
          <div className='content-item' style={{padding: '0px'}}>
            <div className='content-item-block'>
              <div className='b-title'>
                定制化培养
              </div>
              <div className='b-content p-pre-wrap'>
                围绕党组织四类核心人群分层培养，定制差异化人才成长项目，打通从入党积极分子到党组织书记全成长链路，系统化补齐党务履职、党建融业务能力短板，搭建企业自有党务骨干人才梯队。
              </div>
              <div className='wrap-b-desc'>
                <div className='b-desc'>
                  <div className='dot'></div>
                  <div className='text'>
                    <span>新生计划（入党积极分子）：</span>梳理入党全流程规范，夯实党史理论、入党流程基础知识，筑牢思想根基；
                  </div>
                </div>
                <div className='b-desc'>
                  <div className='dot'></div>
                  <div className='text'>
                    <span>先锋计划（业务骨干党员）：</span>聚焦党建嵌入业务落地方法，强化党员带头攻坚、团队凝聚协作能力；
                  </div>
                </div>
                <div className='b-desc'>
                  <div className='dot'></div>
                  <div className='text'>
                    <span>匠人计划（专职党务工作者）：</span>精通全流程党务规范，掌握特色党日创新策划、日常党务精细化运营方法；
                  </div>
                </div>
                <div className='b-desc'>
                  <div className='dot'></div>
                  <div className='text'>
                    <span>领航计划（党组织书记）：</span>提升统筹决策、党建品牌顶层打造、党建引领业务发展的综合领航能力。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </main>
  )
}

export default Cultivate